module.exports = __webpack_public_path__ + "static/shoe-layers-2-c9ba378efb60aa5c3cf2978795ff28a1.png";